module.exports = __webpack_public_path__ + "static/media/buy-red-big.252c0719.png";